import {createStructuredSelector} from "reselect";

export const dealSearchScreenDetailFormSelector = createStructuredSelector({
    isOpen: state => state.dealSearchScreens.detailForm.isOpen,
    formType: state => state.dealSearchScreens.detailForm.formType,
    selectedAreas: state => state.dealSearchScreens.detailForm.selectedAreas,
    selectedIndustries: state => state.dealSearchScreens.detailForm.selectedIndustries,
    selectedBudgets: state => state.dealSearchScreens.detailForm.selectedBudgets,
});
